var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.pageType === "contractList"
        ? _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ]
            },
            [
              _c(
                "div",
                { staticClass: "filter-container" },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      clearable: "",
                      type: "text",
                      placeholder: "合同编号"
                    },
                    model: {
                      value: _vm.listQuery.contractNo,
                      callback: function($$v) {
                        _vm.$set(_vm.listQuery, "contractNo", $$v)
                      },
                      expression: "listQuery.contractNo"
                    }
                  }),
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      clearable: "",
                      type: "text",
                      placeholder: "合同名称"
                    },
                    model: {
                      value: _vm.listQuery.contractName,
                      callback: function($$v) {
                        _vm.$set(_vm.listQuery, "contractName", $$v)
                      },
                      expression: "listQuery.contractName"
                    }
                  }),
                  _c("el-date-picker", {
                    attrs: {
                      format: "yyyy - MM- dd",
                      "value-format": "yyyy-MM-dd",
                      type: "daterange",
                      "range-separator": "至",
                      "start-placeholder": "合同开始日期",
                      "end-placeholder": "合同结束日期"
                    },
                    model: {
                      value: _vm.dates,
                      callback: function($$v) {
                        _vm.dates = $$v
                      },
                      expression: "dates"
                    }
                  }),
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      clearable: "",
                      type: "text",
                      placeholder: "租户姓名"
                    },
                    model: {
                      value: _vm.listQuery.customerName,
                      callback: function($$v) {
                        _vm.$set(_vm.listQuery, "customerName", $$v)
                      },
                      expression: "listQuery.customerName"
                    }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      attrs: { clearable: "", placeholder: "请选择小区名称" },
                      on: { change: _vm.handleAreaGroupSelect },
                      model: {
                        value: _vm.listQuery.areaGroupId,
                        callback: function($$v) {
                          _vm.$set(_vm.listQuery, "areaGroupId", $$v)
                        },
                        expression: "listQuery.areaGroupId"
                      }
                    },
                    _vm._l(_vm.options, function(item) {
                      return _c("el-option", {
                        key: item.dicValue,
                        attrs: {
                          label: item.dicName,
                          value: parseInt(item.dicValue)
                        }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      attrs: { clearable: "", placeholder: "请选择楼宇" },
                      model: {
                        value: _vm.listQuery.buildingId,
                        callback: function($$v) {
                          _vm.$set(_vm.listQuery, "buildingId", $$v)
                        },
                        expression: "listQuery.buildingId"
                      }
                    },
                    _vm._l(_vm.buildingOption, function(item) {
                      return _c("el-option", {
                        key: item.buildingId,
                        attrs: {
                          label: item.buildingName,
                          value: item.buildingId
                        }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      attrs: { clearable: "", placeholder: "请选择停车场" },
                      model: {
                        value: _vm.listQuery.garageId,
                        callback: function($$v) {
                          _vm.$set(_vm.listQuery, "garageId", $$v)
                        },
                        expression: "listQuery.garageId"
                      }
                    },
                    _vm._l(_vm.garageOption, function(item) {
                      return _c("el-option", {
                        key: item.garageId,
                        attrs: { label: item.garageName, value: item.garageId }
                      })
                    }),
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { "margin-top": "10px" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleFilter }
                        },
                        [_vm._v(_vm._s(_vm.$t("button.search")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-download" },
                          on: { click: _vm.handleExport }
                        },
                        [_vm._v("导出Excel")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            icon: "el-icon-circle-plus-outline"
                          },
                          on: { click: _vm.handleCreate }
                        },
                        [_vm._v("新建合同")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading"
                    }
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.list,
                    "element-loading-text": "数据正在加载中...",
                    border: "",
                    stripe: "",
                    fit: "",
                    "highlight-current-row": ""
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("table.id"),
                      width: "50"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "合同编号" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "link-type",
                                  on: {
                                    click: function($event) {
                                      return _vm.getcontractDetail(scope.row)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.contractNo))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      106357374
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "合同名称",
                      "min-width": "120px",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.contractName))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1575090739
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "合同类型" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.leaseType === 1
                                ? _c("span", [_vm._v("房间")])
                                : _c("span", [_vm._v("停车位")])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2168320938
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "小区名称",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.areaGroupName))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3749087369
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "楼宇/停车场",
                      "min-width": "120px",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.buildingName))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3496157463
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "租户" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "link-type",
                                  on: {
                                    click: function($event) {
                                      return _vm.getCustomerDetail(
                                        scope.row.customerId,
                                        scope.row.id
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(scope.row.customerName))]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      526910558
                    )
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "合同状态" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.contractTypeName))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2325785931
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "合同开始日期",
                      "min-width": "120px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.beginDate))])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2549305237
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "合同结束日期",
                      "min-width": "120px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.endDate))])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1215041949
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "退租日期",
                      "min-width": "120px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.refundTime))])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1409983421
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "续签合同",
                      "min-width": "120px",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.upContractName))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2656808886
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "备注",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.remark))])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      186672324
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "租赁面积(m²)",
                      "min-width": "120px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [
                                _vm._v(_vm._s(scope.row.totalHouseArea))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1232991543
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "费用合计(元)",
                      "min-width": "120px",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c("span", [_vm._v(_vm._s(scope.row.amount))])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1167497322
                    )
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: _vm.$t("table.actions"),
                      "class-name": "small-padding fixed-width",
                      "min-width": "220px"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.contractType === 1
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        width: "170"
                                      },
                                      model: {
                                        value: scope.row.showExaminePopover,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "showExaminePopover",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.showExaminePopover"
                                      }
                                    },
                                    [
                                      _c("p", [_vm._v("请确认是否执行合同?")]),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                            margin: "0"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "text"
                                              },
                                              on: {
                                                click: function($event) {
                                                  scope.row.showExaminePopover = false
                                                }
                                              }
                                            },
                                            [_vm._v("取消")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleExecutionContract(
                                                    scope.$index,
                                                    scope.row.id,
                                                    scope.row.leaseType
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("确定")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px"
                                          },
                                          attrs: {
                                            slot: "reference",
                                            type: "primary",
                                            size: "mini",
                                            plain: ""
                                          },
                                          slot: "reference"
                                        },
                                        [_vm._v("审核")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.contractType !== 1 &&
                              scope.row.contractType !== 6 &&
                              !scope.row.upContractId
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        plain: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleRenewal(scope.row.id)
                                        }
                                      }
                                    },
                                    [_vm._v("续签")]
                                  )
                                : _vm._e(),
                              scope.row.contractType === 4
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        plain: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleRentCancellation(
                                            scope.row
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("退租")]
                                  )
                                : _vm._e(),
                              scope.row.contractType === 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        size: "mini",
                                        plain: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleUpdate(
                                            scope.row.id,
                                            scope.row.leaseType
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("更改")]
                                  )
                                : _vm._e(),
                              scope.row.contractType === 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "mini",
                                        plain: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleDelete(scope.row.id)
                                        }
                                      }
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                              scope.row.contractType === 5
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        width: "170"
                                      },
                                      model: {
                                        value: scope.row.showDestrutionPopover,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "showDestrutionPopover",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.showDestrutionPopover"
                                      }
                                    },
                                    [
                                      _c("p", [_vm._v("请确认是否销毁合同?")]),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                            margin: "0"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "text"
                                              },
                                              on: {
                                                click: function($event) {
                                                  scope.row.showDestrutionPopover = false
                                                }
                                              }
                                            },
                                            [_vm._v("取消")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleDestructionContract(
                                                    scope.$index,
                                                    scope.row.id,
                                                    scope.row.leaseType
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("确定")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px"
                                          },
                                          attrs: {
                                            slot: "reference",
                                            type: "danger",
                                            size: "mini",
                                            plain: ""
                                          },
                                          slot: "reference"
                                        },
                                        [_vm._v("销毁")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              scope.row.contractType === 2 ||
                              scope.row.contractType === 3
                                ? _c(
                                    "el-popover",
                                    {
                                      attrs: {
                                        placement: "bottom",
                                        width: "170"
                                      },
                                      model: {
                                        value: scope.row.showTerminationPopover,
                                        callback: function($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "showTerminationPopover",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "scope.row.showTerminationPopover"
                                      }
                                    },
                                    [
                                      _c("p", [_vm._v("请确认是否终止合同?")]),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                            margin: "0"
                                          }
                                        },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                size: "mini",
                                                type: "text"
                                              },
                                              on: {
                                                click: function($event) {
                                                  scope.row.showTerminationPopover = false
                                                }
                                              }
                                            },
                                            [_vm._v("取消")]
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                size: "mini"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.handleTerminationContract(
                                                    scope.$index,
                                                    scope.row.id,
                                                    scope.row.leaseType
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("确定")]
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px"
                                          },
                                          attrs: {
                                            slot: "reference",
                                            type: "danger",
                                            size: "mini",
                                            plain: ""
                                          },
                                          slot: "reference"
                                        },
                                        [_vm._v("终止")]
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1720870632
                    )
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-container" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.listQuery.page,
                      "page-sizes": [10, 20, 30, 50],
                      "page-size": _vm.listQuery.limit,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.total
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "topInfo" },
                [
                  _c("div", { staticClass: "contractMonth" }, [
                    _c("h2", [
                      _vm._v(_vm._s(_vm.currentYearAndMonth) + "合同到期预警")
                    ]),
                    _c("span", [
                      _vm._v(
                        " (" + _vm._s(_vm.constractWarnSum) + "份合同到期)"
                      )
                    ])
                  ]),
                  _c("el-date-picker", {
                    attrs: {
                      type: "month",
                      "value-format": "yyyy-MM",
                      placeholder: "选择月"
                    },
                    on: { change: _vm.handleMonthChange },
                    model: {
                      value: _vm.currentMonth,
                      callback: function($$v) {
                        _vm.currentMonth = $$v
                      },
                      expression: "currentMonth"
                    }
                  })
                ],
                1
              ),
              _c("baseBarChart", {
                attrs: {
                  "x-axis-data": _vm.dayList,
                  "series-data": _vm.sumList,
                  width: 86,
                  height: 30
                }
              }),
              _c(
                "div",
                {
                  staticClass: "filter-container",
                  staticStyle: { "margin-top": "20px" }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      clearable: "",
                      type: "text",
                      placeholder: "请输入合同编号"
                    },
                    model: {
                      value: _vm.warnListQuery.contractNo,
                      callback: function($$v) {
                        _vm.$set(_vm.warnListQuery, "contractNo", $$v)
                      },
                      expression: "warnListQuery.contractNo"
                    }
                  }),
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      clearable: "",
                      type: "text",
                      placeholder: "请输入合同名称"
                    },
                    model: {
                      value: _vm.warnListQuery.contractName,
                      callback: function($$v) {
                        _vm.$set(_vm.warnListQuery, "contractName", $$v)
                      },
                      expression: "warnListQuery.contractName"
                    }
                  }),
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      clearable: "",
                      type: "text",
                      placeholder: "租户姓名"
                    },
                    model: {
                      value: _vm.warnListQuery.customerName,
                      callback: function($$v) {
                        _vm.$set(_vm.warnListQuery, "customerName", $$v)
                      },
                      expression: "warnListQuery.customerName"
                    }
                  }),
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      attrs: { clearable: "", placeholder: "请选择小区名称" },
                      on: { change: _vm.handleWarnAreaGroupSelect },
                      model: {
                        value: _vm.warnListQuery.areaGroupId,
                        callback: function($$v) {
                          _vm.$set(_vm.warnListQuery, "areaGroupId", $$v)
                        },
                        expression: "warnListQuery.areaGroupId"
                      }
                    },
                    _vm._l(_vm.options, function(item) {
                      return _c("el-option", {
                        key: item.dicValue,
                        attrs: {
                          label: item.dicName,
                          value: parseInt(item.dicValue)
                        }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      attrs: { clearable: "", placeholder: "请选择楼宇" },
                      model: {
                        value: _vm.warnListQuery.buildingId,
                        callback: function($$v) {
                          _vm.$set(_vm.warnListQuery, "buildingId", $$v)
                        },
                        expression: "warnListQuery.buildingId"
                      }
                    },
                    _vm._l(_vm.buildingOption, function(item) {
                      return _c("el-option", {
                        key: item.buildingId,
                        attrs: {
                          label: item.buildingName,
                          value: item.buildingId
                        }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticClass: "form-item-width",
                      attrs: { clearable: "", placeholder: "请选择停车场" },
                      model: {
                        value: _vm.warnListQuery.garageId,
                        callback: function($$v) {
                          _vm.$set(_vm.warnListQuery, "garageId", $$v)
                        },
                        expression: "warnListQuery.garageId"
                      }
                    },
                    _vm._l(_vm.garageOption, function(item) {
                      return _c("el-option", {
                        key: item.garageId,
                        attrs: { label: item.garageName, value: item.garageId }
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      directives: [{ name: "waves", rawName: "v-waves" }],
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.handleWarnFilter }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.search")))]
                  )
                ],
                1
              ),
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading"
                    }
                  ],
                  staticStyle: {
                    width: "100%",
                    "max-height": "441px",
                    "overflow-y": "scroll"
                  },
                  attrs: {
                    data: _vm.warnList,
                    "element-loading-text": "数据正在加载中...",
                    border: "",
                    stripe: "",
                    fit: "",
                    "highlight-current-row": ""
                  },
                  on: { "selection-change": _vm.handleSelectionChange }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: _vm.$t("table.id"),
                      width: "50"
                    }
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "合同编号" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "link-type",
                                on: {
                                  click: function($event) {
                                    return _vm.getcontractDetail(scope.row)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(scope.row.contractNo))]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "合同名称" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.contractName))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "小区名称" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.areaGroupName))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: "楼宇/停车场",
                      "show-overflow-tooltip": ""
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.upName))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "租户" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "link-type",
                                on: {
                                  click: function($event) {
                                    return _vm.getCustomerDetail(
                                      scope.row.customerId
                                    )
                                  }
                                }
                              },
                              [_vm._v(_vm._s(scope.row.customerName))]
                            )
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "合同状态" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [
                              _vm._v(_vm._s(scope.row.contractTypeName))
                            ])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "合同开始日期" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.beginDate))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: { align: "center", label: "合同结束日期" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            _c("span", [_vm._v(_vm._s(scope.row.endDate))])
                          ]
                        }
                      }
                    ])
                  }),
                  _c("el-table-column", {
                    attrs: {
                      align: "center",
                      label: _vm.$t("table.actions"),
                      "class-name": "small-padding fixed-width"
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(scope) {
                          return [
                            !scope.row.contractType === 1
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: ""
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleRenewal(scope.row.id)
                                      }
                                    }
                                  },
                                  [_vm._v("续签")]
                                )
                              : _vm._e(),
                            scope.row.contractType === 2 ||
                            scope.row.contractType === 3
                              ? _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      placement: "bottom",
                                      width: "170"
                                    },
                                    model: {
                                      value: scope.row.showTerminationPopover,
                                      callback: function($$v) {
                                        _vm.$set(
                                          scope.row,
                                          "showTerminationPopover",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "scope.row.showTerminationPopover"
                                    }
                                  },
                                  [
                                    _c("p", [_vm._v("请确认是否终止合同?")]),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          "text-align": "right",
                                          margin: "0"
                                        }
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              size: "mini",
                                              type: "text"
                                            },
                                            on: {
                                              click: function($event) {
                                                scope.row.showTerminationPopover = false
                                              }
                                            }
                                          },
                                          [_vm._v("取消")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "primary",
                                              size: "mini"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.handleTerminationContract2(
                                                  scope.$index,
                                                  scope.row.id,
                                                  scope.row.leaseType
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v("确定")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          slot: "reference",
                                          type: "danger",
                                          size: "mini",
                                          plain: ""
                                        },
                                        slot: "reference"
                                      },
                                      [_vm._v("终止")]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "1000px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("contract-add", {
            attrs: {
              "is-add-contract": _vm.isAddContract,
              "contract-add-data": _vm.baseData,
              "show-dialog": _vm.dialogFormVisible
            },
            on: {
              transmitHouseContractData: _vm.receiveHouseAddData,
              transmitParkingLotContractData: _vm.receiveParkingLotAddData,
              handCancle: _vm.handCancle
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogHouseContractVisible,
            width: "1000px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogHouseContractVisible = $event
            }
          }
        },
        [
          _c("house-contract", {
            attrs: {
              "is-add-contract": _vm.isAddContract,
              "contract-bond-list": _vm.bondList,
              "contract-clause-list": _vm.clauseList,
              "base-info": _vm.baseInfoObj,
              "key-value": _vm.contractId,
              "house-list": _vm.houseList,
              "show-dialog": _vm.dialogHouseContractVisible
            },
            on: {
              generatingBills: _vm.receiveHouseContractData,
              handCancle: _vm.handCancle
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogParkingLotContractVisible,
            width: "1100px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogParkingLotContractVisible = $event
            }
          }
        },
        [
          _c("parking-lot-contract", {
            attrs: {
              "is-add-contract": _vm.isAddContract,
              "parking-lot-list": _vm.parkingLotList,
              "contract-standard-list": _vm.standardList,
              "base-info": _vm.baseInfoObj,
              "contract-clause-list": _vm.parkClauseList,
              "show-dialog": _vm.dialogParkingLotContractVisible
            },
            on: {
              generatingBills: _vm.receiveParkingLotContractData,
              handCancle: _vm.handCancle
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogHouseBillVisible,
            width: "1000px",
            title: _vm.title
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogHouseBillVisible = $event
            }
          }
        },
        [
          _c("house-bill", {
            attrs: {
              "show-dialog": _vm.dialogHouseBillVisible,
              "renewal-id": _vm.renewalId,
              "could-generate-bill": _vm.couldGenerate,
              "key-value": _vm.contractId,
              "house-list": _vm.houseList,
              "contract-base-data": _vm.houseAddData,
              "clause-list-data": _vm.houseClauseList,
              "bond-list-data": _vm.houseBondList
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogParkingLotBillVisible,
            width: "1000px",
            title: _vm.title
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogParkingLotBillVisible = $event
            }
          }
        },
        [
          _c("parking-lot-bill", {
            attrs: {
              "show-dialog": _vm.dialogParkingLotBillVisible,
              "renewal-id": _vm.renewalId,
              "parking-lotlist": _vm.parkingLotList,
              "could-generate-bill": _vm.couldGenerate,
              "key-value": _vm.contractId,
              "contract-base-data": _vm.parkingLotAddData,
              "clause-list-data": _vm.parkLotClauseList,
              "standard-list-data": _vm.parkLotStandardList
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogExcelVisible,
            width: "500px",
            title: _vm.title
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogExcelVisible = $event
            }
          }
        },
        [
          _c("importExcel", {
            attrs: {
              "show-dialog": _vm.dialogExcelVisible,
              "contract-base-data": _vm.houseAddData
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogCustomerFormVisible,
            width: "920px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogCustomerFormVisible = $event
            }
          }
        },
        [
          _c("customer-detail", {
            attrs: {
              "key-value": _vm.customerId,
              "show-dialog": _vm.dialogCustomerFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogContractFormVisible,
            width: "1000px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogContractFormVisible = $event
            }
          }
        },
        [
          _c("contract-detail", {
            attrs: {
              "constract-obj": _vm.contractData,
              "show-dialog": _vm.dialogContractFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogCostFormVisible,
            width: "800px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogCostFormVisible = $event
            }
          }
        },
        [
          _c("cost-detail", {
            attrs: {
              "key-value": _vm.contractId,
              "show-dialog": _vm.dialogCostFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogRentVisible,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogRentVisible = $event
            }
          }
        },
        [
          _c("return-rent", {
            attrs: {
              "key-value": _vm.contractData,
              "show-dialog": _vm.dialogRentVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogRentAgreementVisible,
            width: "1000px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogRentAgreementVisible = $event
            }
          }
        },
        [
          _c("return-rent-agreement", {
            attrs: {
              "key-value": _vm.contractId,
              "is-confirm": _vm.isRentConfirm,
              "show-dialog": _vm.dialogRentAgreementVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }